import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLichessComponent } from './simple-icons-lichess.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLichessComponent ],
    exports:      [ SimpleIconsLichessComponent ],
    bootstrap:    []
})
export class SimpleIconsLichessModule {}
